import {
  SET_PROMOTION,
  SET_IS_LOADING_PROMOTIONS,
  SET_TOKEN_FOR_CREDIT_LINE,
  SET_TOKEN_FOR_INSTALLMENT_CREDIT,
  SET_IS_LOADING_CREDIT_LINE_TOKEN,
  SET_IS_LOADING_INSTALLMENT_CREDIT_TOKEN,
  SET_IS_LOADING_CREDIT_WITH_ACCOUNT_TOKEN,
  SET_TOKEN_FOR_CREDIT_WITH_ACCOUNT,
} from './actionTypes';

export const initialState = {
  promotions: [],
  isPromotionsLoading: true,
  tokenForCreditLineWidget: null,
  tokenForCreditWithAccountWidget: null,
  tokenForInstallmentCreditWidget: null,
  isCreditLineTokenLoading: true,
  isCreditWithAccountTokenLoading: true,
  isInstallmentCreditTokenLoading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PROMOTION: {
      return {
        ...state,
        promotions: action.payload,
      };
    }
    case SET_IS_LOADING_PROMOTIONS: {
      return {
        ...state,
        isPromotionsLoading: action.payload,
      };
    }
    case SET_TOKEN_FOR_CREDIT_LINE: {
      return {
        ...state,
        tokenForCreditLineWidget: action.payload,
      };
    }
    case SET_IS_LOADING_CREDIT_LINE_TOKEN: {
      return {
        ...state,
        isCreditLineTokenLoading: action.payload,
      };
    }
    case SET_TOKEN_FOR_CREDIT_WITH_ACCOUNT: {
      return {
        ...state,
        tokenForCreditWithAccountWidget: action.payload,
      };
    }
    case SET_IS_LOADING_CREDIT_WITH_ACCOUNT_TOKEN: {
      return {
        ...state,
        isCreditWithAccountTokenLoading: action.payload,
      };
    }
    case SET_TOKEN_FOR_INSTALLMENT_CREDIT: {
      return {
        ...state,
        tokenForInstallmentCreditWidget: action.payload,
      };
    }
    case SET_IS_LOADING_INSTALLMENT_CREDIT_TOKEN: {
      return {
        ...state,
        isInstallmentCreditTokenLoading: action.payload,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
